<template>
    <form @submit.prevent="submit">
        <slot />
    </form>
</template>

<script>
export default {
	emits: ['submit'],
    methods: {
        submit(e) {
            if (this.isFormLoading()) {
                return
            }

            this.$emit('submit', e)
        },
        isFormLoading() {
            return this.$el.querySelectorAll('.btn.loading').length !== 0
        },
    },
}
</script>
